import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20e518de&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=20e518de&prod&lang=less&scoped=true"
import style1 from "@Ai/sections/catalog-model-sets/catalog-drawer.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e518de",
  null
  
)

export default component.exports